<!--
  Initial-load splash. Full-viewport overlay shown until the app's first data
  is in and a minimum display duration has passed. Centered pulsing heart in
  the same visual language as the floating brand heart.
-->
<template>
    <div
        class="loading-screen"
        aria-hidden="true"
    >
        <div class="loading-screen__heart">
            <span class="loading-screen__halo"></span>
            <svg
                class="loading-screen__mark"
                viewBox="0 0 24 24"
                width="36"
                height="36"
                aria-hidden="true"
            >
                <path
                    d="M12,21.35 L10.55,20.03 C5.4,15.36 2,12.27 2,8.5 C2,5.41 4.42,3 7.5,3 C9.24,3 10.91,3.81 12,5.08 C13.09,3.81 14.76,3 16.5,3 C19.58,3 22,5.41 22,8.5 C22,12.27 18.6,15.36 13.45,20.04 L12,21.35 Z"
                    fill="currentColor"
                />
            </svg>
        </div>
    </div>
</template>

<script>
export default {
    name: 'LoadingScreen'
}
</script>

<style lang="scss" scoped>
.loading-screen {
    position: fixed;
    inset: 0;
    z-index: 10000;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #000;
}

.loading-screen__heart {
    position: relative;
    width: 88px;
    height: 88px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background-color: #fff;
    /* Heart glyph in brand pink (was ink-black). Visual continuity
       with the floating heart on Home.vue. */
    color: var(--bzioup-color-pink, #da8a8b);
    box-shadow:
        0 10px 30px rgba(0, 0, 0, 0.35),
        0 2px 4px   rgba(0, 0, 0, 0.20);
}

.loading-screen__halo {
    position: absolute;
    inset: 0;
    border-radius: 50%;
    pointer-events: none;
    /* Halo also turns pink. radiates the brand color out from the
       badge as the page loads. */
    box-shadow: 0 0 0 0 rgba(218, 138, 139, 0.55);
    animation: loading-heart-halo 1.8s ease-out infinite;
}

.loading-screen__mark {
    position: relative;
    display: block;
    animation: loading-heart-beat 1.8s ease-in-out infinite;
}

@keyframes loading-heart-halo {
    0%   { box-shadow: 0 0 0 0    rgba(218, 138, 139, 0.55); }
    70%  { box-shadow: 0 0 0 26px rgba(218, 138, 139, 0); }
    100% { box-shadow: 0 0 0 0    rgba(218, 138, 139, 0); }
}

@keyframes loading-heart-beat {
    0%, 100% { transform: scale(1); }
    15%, 35% { transform: scale(1.10); }
    20%, 40% { transform: scale(0.95); }
}
</style>
